import { compose } from "redux";
import { IAction } from "../../../models/Action";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import emptyState from "./emptyState";

import { pipe } from "ramda";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IOfficeItemProps } from "../../../components/OfficesList/module/constants";
import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const {
  OFFICES,
  SELECTED_OFFICE,
  STEP_ONE,
  STEP_TWO,
  BUSINESS_ROLES,
  SELECTED_BR,
  SELECTED_BR_ENTITLEMENTS,
  BR,
  DESCRIPTION,
  NAME,
  ENTITLEMENTS,
  CHAIN_ENTITLEMENTS,
  REQUEST_STATE,
  SOD_CONFLICTS_BR,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.SELECT_OFFICE]: (state: any, action: any) =>
    immutableSet([SELECTED_OFFICE], action.payload, state),
  [actionTypes.SELECT_BR]: (state: any, action: any) =>
    pipe(
      immutableSet([SELECTED_BR], Object.assign(action.payload)),
      immutableSet([BR, NAME], action.payload.name + ""),
      immutableSet([BR, DESCRIPTION], action.payload.description + "")
    )(state),
  [actionTypes.SET_BR_NAME]: (state: any, action: any) =>
    immutableSet([BR, NAME], action.payload, state),
  [actionTypes.SET_BR_DESCRIPTION]: (state: any, action: any) =>
    immutableSet([BR, DESCRIPTION], action.payload, state),
  [actionTypes.SET_ENTITLEMENTS_BR]: (state: any, action: any) => {
    const fineEntitlementList =
      action.payload.length > 0 &&
      action.payload.map((entitlement: any) => {
        return {
          ...entitlement,
          identitySystemId:
            IDENTITY_SYSTEM[
              entitlement.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
        };
      });
    // return immutableSet([BR, ENTITLEMENTS], fineEntitlementList, state);
    return immutableSet(
      [SELECTED_BR_ENTITLEMENTS, LIST_IDENTIFIER],
      fineEntitlementList,
      state
    );
  },
  [actionTypes.SET_CHAIN_ENTITLEMENTS_BR]: (state: any, action: any) =>
    immutableSet([BR, CHAIN_ENTITLEMENTS], action.payload, state),

  [actionTypes.OFFICE_REQUEST_BR_MANAGEMENT]: (state: any, action: any) =>
    immutableSet([STEP_ONE, OFFICES, LOADER_IDENTIFIER], true, state),
  [actionTypes.OFFICE_REQUEST_BR_MANAGEMENT_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const tempBRItems: IOfficeItemProps[] = [];
    action.payload.map((office: any) => {
      const tempBRItem: IOfficeItemProps = {
        organizational_unit: office.name,
        organizational_unit_code: office.ou,
        organizational_unit_type: "",
        identitySystemId: office.identitySystemId,
        delegator: office.delegator,
      };
      tempBRItems.push(tempBRItem);
    });
    return compose(
      immutableSet([STEP_ONE, OFFICES, LIST_IDENTIFIER], tempBRItems),
      immutableSet([STEP_ONE, OFFICES, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.OFFICE_REQUEST_BR_MANAGEMENT_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_ONE, OFFICES, LIST_IDENTIFIER], []),
      immutableSet([STEP_ONE, OFFICES, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.BR_BY_OFFICE_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_TWO, BUSINESS_ROLES, LOADER_IDENTIFIER], true, state),
  [actionTypes.BR_BY_OFFICE_REQUEST_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_TWO, BUSINESS_ROLES, LIST_IDENTIFIER], action.payload),
      immutableSet([STEP_TWO, BUSINESS_ROLES, LOADER_IDENTIFIER], false)
    )(state),
  [actionTypes.BR_BY_OFFICE_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_TWO, BUSINESS_ROLES, LIST_IDENTIFIER], []),
      immutableSet([STEP_TWO, BUSINESS_ROLES, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.ENTITLEMENT_BY_OU_REQUEST]: (state: any, action: any) =>
    immutableSet([ENTITLEMENTS, LOADER_IDENTIFIER], true, state),

  [actionTypes.ENTITLEMENT_BY_OU_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload
        .filter((entitlement: any) => entitlement.showOnFrontend)
        .forEach((data: any) => {
          const tempRow: {} = {
            entitlement_id: data.entitlement_id,
            application_name: data.application_name,
            application_description: data.application_description,
            entitlement_name: data.entitlement_name,
            entitlement_description: data.entitlement_description,
            application_id: data.application_id,
            identity_system_id: data.identity_system_id,
            identitySystemId:
              IDENTITY_SYSTEM[
                data.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
            chainEntitlementsIds: data.chainEntitlementsIds,
            editable: data.editable,
            deleted: false,
            added: false,
            validable: data.validable,
            monoProfilo: data.monoProfilo,
            involvedInSOD: data.involvedInSOD,
            temporary: data.temporary,
          };
          mappedResponse.push(tempRow);
        });
    return compose(
      immutableSet([ENTITLEMENTS, LIST_IDENTIFIER], mappedResponse),
      immutableSet([ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.ENTITLEMENT_BY_OU_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([ENTITLEMENTS, LIST_IDENTIFIER], []),
      immutableSet([ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.GET_BR_ENTITLEMENTS]: (state: any, action: any) =>
    compose(
      immutableSet([SELECTED_BR_ENTITLEMENTS, LIST_IDENTIFIER], []),
      immutableSet([SELECTED_BR_ENTITLEMENTS, LOADER_IDENTIFIER], true)
    )(state),
  [actionTypes.GET_BR_ENTITLEMENTS_SUCCESS]: (state: any, action: any) => {
    const fineEntitlementList =
      action.payload.length > 0 &&
      action.payload.map((entitlement: any) => {
        return {
          ...entitlement,
          identitySystemId:
            IDENTITY_SYSTEM[
              entitlement.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
        };
      });
    return compose(
      immutableSet(
        [SELECTED_BR_ENTITLEMENTS, LIST_IDENTIFIER],
        fineEntitlementList
      ),
      immutableSet([SELECTED_BR_ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.GET_BR_ENTITLEMENTS_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([SELECTED_BR_ENTITLEMENTS, LIST_IDENTIFIER], []),
      immutableSet([SELECTED_BR_ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.CREATE_BR_REQUEST]: (state: any, action: any) =>
    immutableSet([BR, REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.CREATE_BR_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([BR, REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.CREATE_BR_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([BR, REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.MODIFY_BR_REQUEST]: (state: any, action: any) =>
    immutableSet([BR, REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.MODIFY_BR_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([BR, REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.MODIFY_BR_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([BR, REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_BR_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.DELETE_BR_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.DELETE_BR_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_TWO, REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.SOD_CONFLICTS_BR_SUCCESS]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS_BR], action.payload, state),

  [actionTypes.SOD_CONFLICTS_BR_FAILURE]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS_BR], action.payload, state),

  [actionTypes.RESET_SOD_CONFLICTS_BR]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS_BR], null, state),
  [actionTypes.RESET_STATE_BR_MANAGEMENT]: (state: any, action: any) =>
    emptyState,
  [actionTypes.RESET_BR]: (state: any, action: any) =>
    compose(
      immutableSet([BR, NAME], ""),
      immutableSet([BR, DESCRIPTION], ""),
      immutableSet([BR, ENTITLEMENTS], []),
      immutableSet([BR, CHAIN_ENTITLEMENTS], []),
      immutableSet([SELECTED_BR], {})
    )(state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
